import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { PAGE_TYPE, setPageTitle } from "containers/App/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import Market from "components/Market/Market";
import ProjectOverview from "components/ProjectOverview/ProjectOverview";

import * as marketReducer from "containers/Market/MarketReducer";

class MarketContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    setPageTitle(PAGE_TYPE.MARKETPLACE);
  }

  render() {
    const {} = this.props;

    return <Market {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateMenuType: (menuType) => dispatch(marketReducer.updateMenuType(menuType))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    menuType: marketReducer.getMenuType(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MarketContainer);
